/**
 * Why a Zocdoc-bound visit cannot be transferred to another organisation, shared by the Schedule
 * preview and the appointment modal so both say the same thing.
 *
 * The Zocdoc booking names this organisation's provider; moving the visit elsewhere would leave
 * the marketplace booking pointing at a practitioner who no longer holds it.
 */
export const ZOCDOC_TRANSFER_BLOCKED =
  'Transfer is blocked — this appointment is linked to a Zocdoc booking. Cancel or reschedule it instead.'
